import React, { useEffect } from 'react';
import { StatsigProvider as StatsigProviderComponent, useClientAsyncInit } from '@statsig/react-bindings';
import { getPageEnvByHost } from '@/utils/environment';
import { useStore } from './storeProvider';
import CustomSpinner from '@/common/Spinner';
import { pageView } from '@/utils/google';
import { usePerformanceMeasure } from '@/hooks/usePerformanceMeasure';
import { trace } from '@/utils/trace';

export const StatsigProvider: React.FC = ({ children }) => {
  const { invoiceData } = useStore();
  const user = {
    userID: invoiceData?.sellerId,
  };

  const { client, isLoading } = useClientAsyncInit('client-LJmokBKXH96F2ZdI0ZYDyd27hX7Z8HfNU35XJvv3jxa', user, {
    environment: { tier: getPageEnvByHost() === 'prod' ? 'production' : 'staging' },
  });

  usePerformanceMeasure({
    name: 'STATSIG_INIT',
    ready: !isLoading,
  });

  useEffect(() => {
    pageView();
    trace.mark('main_ready');
  }, []);

  return (
    <StatsigProviderComponent client={client} loadingComponent={<CustomSpinner />}>
      {children}
    </StatsigProviderComponent>
  );
};

export default StatsigProvider;
